import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { setVolumeMuted } from "actions/VolumeActions";
import ControlButton from "components/ControlButton";
import getUseMobileControls from "selectors/breakpoint/getUseMobileControls";
import classnames from "classnames";
import styles from "./UnmuteButton.css";

function UnmuteButton(props) {
  const text = props.useSmallButton ? null : <span>Enable Audio</span>;
  const iconClass = classnames(styles.muteIcon, {
    [styles.muteIconPadded]: !props.useSmallButton,
  });

  return (
    <div
      className={classnames(styles.root, {
        [styles.mobileControls]: props.useSmallButton,
      })}
      onMouseMove={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <ControlButton border={!props.useSmallButton} onClick={props.onClick}>
        <div className={styles.buttonInner}>
          <span className={iconClass} />
          {text}
        </div>
      </ControlButton>
    </div>
  );
}

UnmuteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  useSmallButton: PropTypes.bool.isRequired,
};

export default connect(
  (state) => ({
    useSmallButton: getUseMobileControls(state),
  }),
  (dispatch) => ({
    onClick: () => dispatch(setVolumeMuted(false)),
  }),
)(UnmuteButton);
